import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { setOverallTab } from '../../features/ui/uiSlice';
import SegmentedTabs from '../../components/common/SegmentedTabs';
import OverviewTab from './OverviewTab';
import GeoTab from './geo/GeoTab';

export default function OverallPage() {
  const dispatch = useAppDispatch();
  const overallTab = useAppSelector((s) => s.ui.overallTab);

  return (
    <>
      <SegmentedTabs
        sx={{ mb: 2.25 }}
        value={overallTab}
        onChange={(v) => {
          dispatch(setOverallTab(v));
          window.scrollTo(0, 0);
        }}
        items={[
          { value: 'overview', label: '▦ Overview' },
          { value: 'geo', label: '🗺 Geo / Condition Analysis' },
        ]}
      />
      {overallTab === 'geo' ? <GeoTab /> : <OverviewTab />}
    </>
  );
}
